import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';
import RoleBasedGuard from '@/guards/RoleBasedGuard';
import { InAppPopupCreateEdit, InAppPopupsList } from '../pages';
import { PATH_IN_APP_POPUPS } from './paths';

const IN_APP_POPUP_ROUTES = [
  {
    path: PATH_IN_APP_POPUPS.list,
    roles: ['settings.view'],
    component: <InAppPopupsList />,
    index: true,
  },
  {
    path: PATH_IN_APP_POPUPS.new,
    roles: ['settings.create'],
    component: <InAppPopupCreateEdit />,
    index: false,
  },
  {
    path: PATH_IN_APP_POPUPS.edit,
    roles: ['settings.update'],
    component: <InAppPopupCreateEdit />,
    index: false,
  },
];

export const InAppPopupsRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      {IN_APP_POPUP_ROUTES.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          index={route.index}
          element={
            <RoleBasedGuard roles={route.roles}>
              {route.component}
            </RoleBasedGuard>
          }
        />
      ))}
    </Route>
  </Routes>
);
